import {useEffect} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {marketsStore} from "../stores/MarketsStore";

export const useMarketRoute = () => {
    const { marketId: routeMarketId, tab, filter } = useParams();
    const navigate = useNavigate();
    const currentMarket = marketsStore.currentMarket
    const marketsSize = marketsStore.marketsSize

    useEffect(() => {
        if (!marketsSize) {
            return
        }

        if (routeMarketId) {
            marketsStore.selectMarket(routeMarketId)
        } else {
            marketsStore.selectDefaultMarket()
        }

    }, [routeMarketId, marketsSize]);

    useEffect(() => {
        if (currentMarket?.marketId) {
            if (tab) {
                if (filter) {
                    navigate(`/markets/${currentMarket.marketId}/${tab}/${filter}`);
                } else {
                    navigate(`/markets/${currentMarket.marketId}/${tab}`);
                }
            } else {
                navigate(`/markets/${currentMarket.marketId}`);
            }
        }
    }, [currentMarket?.marketId]);
}